const _DEFAULT = "450"
const _normal = "450"
const _medium = "500"
const _bold = "700"
const _black = "900"
const config = { "DEFAULT": _DEFAULT, "normal": _normal, "medium": _medium, "bold": _bold, "black": _black,  }
export { config as default, _DEFAULT, _normal, _medium, _bold, _black }